import axios from 'axios';
import { $Q } from '../utils/querySelector';

export const getDate = () => {
  const inputSubmit = $Q('.birthdate__submit');
  const inputDate = $Q('#Birthdate');

  if (inputDate) {
    inputDate.max = new Date().toISOString().split('T')[0];

    inputDate.addEventListener('change', () => {
      if (inputDate.value) {
        if (inputDate.value > inputDate.max) {
          $Q('.Birthdate-future__error').classList.remove('hidden');
          inputSubmit.classList.add('hidden');
        } else {
          $Q('.Birthdate-future__error').classList.add('hidden');
          inputSubmit.classList.remove('hidden');
        }
      } else {
        inputSubmit.classList.add('hidden');
      }
    });
  }
};

export const sendDate = () => {
  const inputSubmit = $Q('.birthdate__submit');
  const inputDate = $Q('#Birthdate');

  if (inputSubmit) {
    inputSubmit.addEventListener('click', async () => {
      const customerId = inputDate.dataset.customer;

      const data = {
        id: customerId,
        note: `Birthdate: ${inputDate.value}`,
      };

      const response = await updateCustomer(data);

      if (response === true) {
        window.location.reload();
      }
    });
  }
};

const updateCustomer = async (data) => {
  let result = false;

  result = await fetch(
    'https://klaviyo-api-gr.herokuapp.com/shopifywebhook/update-user',
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return result.ok;
};

/**
 * Register Date In Klaviyo by API
 */
export async function registerDateInKlaviyo(email, birthdate) {
  console.log('register into klaviyo');
  const data = {
    data: {
      type: 'profile',
      attributes: {
        email,
      },
      properties: {
        birthdate,
      },
    },
  };
  const config = {
    params: { company_id: 'TEVGk2' },
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      revision: '2024-02-15',
    },
  };
  try {
    const response = await axios.post(
      'https://a.klaviyo.com/client/profiles',
      data,
      config);
    console.log('Birthdate registered successfully:', response);
  } catch (error) {
    console.log(error);
  }
}
